import { render, staticRenderFns } from "./success-page.vue?vue&type=template&id=5068ca0d&scoped=true&"
import script from "./success-page.vue?vue&type=script&lang=js&"
export * from "./success-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5068ca0d",
  null
  
)

export default component.exports